import { createTypes, completeTypes } from 'redux-recompose';

import SurveyService from 'services/SurveyService';
import { PAYMENT } from 'constants/survey';

export const actions = createTypes(completeTypes(['GET_SURVEY_FORM'], ['CLEAN_SURVEY_FORM']), '@@SURVEY');
const privateActionCreators = {
  getSurveyFormSuccess: form => ({
    type: actions.GET_SURVEY_FORM_SUCCESS,
    payload: form,
    target: 'surveyForm'
  }),
  getSurveyFormFailure: error => ({
    type: actions.GET_SURVEY_FORM_FAILURE,
    payload: { error },
    target: 'surveyForm'
  })
};

const actionCreators = {
  cleanSurveyForm: () => dispatch => dispatch({ type: actions.CLEAN_SURVEY_FORM }),

  getSurveyForm: type => async dispatch => {
    dispatch(actionCreators.cleanSurveyForm());
    dispatch({ type: actions.GET_SURVEY_FORM, target: 'surveyForm' });
    const response =
      type === PAYMENT ? await SurveyService.getPaymentSurvey() : await SurveyService.getProcedureSurvey();
    if (response.ok) {
      dispatch(privateActionCreators.getSurveyFormSuccess({ ...response.data, type }));
    } else {
      dispatch(privateActionCreators.getSurveyFormFailure(response.data));
    }
  }
};

export default actionCreators;
